import React, { Component } from "react";
import ReactDOM from "react-dom";

import PropTypes from "prop-types";
import { Button, DialogContainer } from "react-md";
const modalRoot = document.getElementById("modal-root");

class ConfirmDialog extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: true };
    // Create a div that we'll render the modal into. Because each
    // Modal component has its own element, we can render multiple
    // modal components into the modal container.
    this.el = document.createElement("div");
  }

  componentDidMount() {
    // Append the element into the DOM on mount. We'll render
    // into the modal container element (see the HTML tab).
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    // Remove the element from the DOM when we unmount
    modalRoot.removeChild(this.el);
  }

  onHide = () => this.setState({ visible: false });

  render() {
    let actions = [
      this.props.okButtonText && <Button raised primary onClick={this.props.onOkClick}>{this.props.okButtonText}</Button>,
      this.props.cancelButtonText && <Button flat primary onClick={this.props.onCancelClick}>{this.props.cancelButtonText}</Button>
    ];

    // Use a portal to render the children into the element
    return ReactDOM.createPortal(
      <DialogContainer
        title={this.props.title}
        id={"confirm-dialog"}
        visible={this.state.visible}
        onHide={this.onHide}
        actions={actions}
        stackedActions={false}
        width={500}
        modal={true}
        portal={true}
      >
        {this.props.message}
        {this.props.question}
      </DialogContainer>,
      // A DOM element
      this.el,
    );
  }
}

ConfirmDialog.propTypes = {
  onOkClick: PropTypes.func.isRequired,
  okButtonText: PropTypes.string,
  onCancelClick: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  title: PropTypes.node,
  message: PropTypes.node,
  question: PropTypes.node,
};

ConfirmDialog.defaultProps = {
  okButtonText: "Confirm",
  cancelButtonText: "Cancel",
  title: "Confirm",
  question: null,
  message: null,
};

export default ConfirmDialog;
